export default __webpack_public_path__ + "static/media/chevron.d535d72e.svg";